import {
    ensureNotificationHandlerRegistered,
    addNotification as addHeaderToastNotification,
    NotificationActionType,
    NotificationViewState,
} from 'owa-header-toast-notification';

export interface InternalNotificationViewState extends NotificationViewState {
    actionContext: InternalNotificationContext<{}>;
}

export interface InternalNotificationContext<T> {
    onNotificationClick: (context: T) => void;
    context: T;
}

/**
 * Function called on App bootstrap, register the peopleHubNotificationHandler to respond to PH toasts
 */
export function registerNotificationHandler(): void {
    ensureNotificationHandlerRegistered(
        NotificationActionType.PeopleHubNotification,
        notificationHandler
    );
}

/**
 * Function invoked by the owa-header-toast-notification package when a notification of type PeopleHubNotification is clicked
 * Takes care of invoking the onNotificationClick callback passed in the viewState
 * with the notification context passed in addPeoplehubNotification
 */
function notificationHandler(notificationState: InternalNotificationViewState): void {
    const actionContext = notificationState.actionContext;
    if (actionContext?.onNotificationClick) {
        actionContext.onNotificationClick(actionContext.context);
    }
}

let headerToastNotificationId = 0;

/**
 * Display a Toast Notification on the top-right of the screen.
 * @param title The title of the notification
 * @param description Error message/toast description
 * @param actionLink Text to be displayed explaining the action that will be taken by clicking the toast (E.g.: Try again)
 * @param cancelLink Text indicating the Cancel action, clicking will only dismiss the notification
 * @param onNotificationClick Function invoked when clicking the notification. Will be invoked with @param context as a parameter
 * @param context Object of type T, passed as a parameter to @param onNotificationClick
 */
export function addNotification<T>(
    title: string,
    description?: string,
    actionLink?: string,
    cancelLink?: string,
    onNotificationClick?: (context: T) => void,
    context?: T
): void {
    const phContext: InternalNotificationContext<T> = {
        onNotificationClick: onNotificationClick,
        context,
    };

    addHeaderToastNotification({
        id: headerToastNotificationId++,
        actionType: NotificationActionType.PeopleHubNotification,
        title,
        description,
        actionLink,
        cancelLink,
        actionContext: phContext,
    });
}
